import { FieldHasValue, ValidateNumberField, ValidateField } from 'helpers/Validation';

export const FoundResultAsFoundResultFormula = (formData) => {
    if (FieldHasValue(formData.F206AftIndependentReading1)
        && FieldHasValue(formData.F207AftIndependentReading2)
        && FieldHasValue(formData.F208AftIndependentReading3)
        && FieldHasValue(formData.F209AftTxreading1)
        && FieldHasValue(formData.F210AftTxreading2)
        && FieldHasValue(formData.F211AftTxreading3)
        && FieldHasValue(formData.F106AftHmireading1)
        && FieldHasValue(formData.F107AftHmireading2)
        && FieldHasValue(formData.F108AftHmireading3)
        && FieldHasValue(formData.F215AftDeviation1)
        && FieldHasValue(formData.F216AftDeviation2)
        && FieldHasValue(formData.F217AftDeviation3)
        && FieldHasValue(formData.F101AftTolerance)) {
        if (Math.max(ValidateField(formData.F215AftDeviation1), ValidateField(formData.F216AftDeviation2),
        ValidateField(formData.F217AftDeviation3)) <= ValidateNumberField(formData.F101AftTolerance)) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
export const ReCalibrationNeeded = (formData) => {
    if (FieldHasValue(formData.F102AftResult)) {
        if (Math.max(ValidateNumberField(formData.F215AftDeviation1),
        ValidateNumberField(formData.F216AftDeviation2), ValidateNumberField(formData.F217AftDeviation3)) <= 2) {
            return 'NO';
        }
        return 'YES';
    }
    return '';
};
